module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/shared-components/cotizacion/cotizacion.component.scss
// module id = ./src/app/shared-components/cotizacion/cotizacion.component.scss
// module chunks = main